import { useRef } from 'react'
import { motion, useInView } from 'framer-motion'

const BOOKMAKERS = [
  'Bet365',
  'William Hill',
  'Betway',
  'Ladbrokes',
  'Betfair',
  'Unibet',
  'Pinnacle',
  '888sport',
  'Bwin',
  'Coral',
  'Paddy Power',
  'Sky Bet',
  'Betfred',
  '10Bet',
  'Betsson',
  'Betvictor',
  'Interwetten',
  'Marathonbet',
  'Sportingbet',
  '1xBet',
]

export function BookmakerGrid() {
  const ref = useRef<HTMLElement>(null)
  const isInView = useInView(ref, { once: true, margin: '-100px' })

  return (
    <section ref={ref} className="bookmakers-section">
      <motion.h2
        className="bookmakers-title"
        initial={{ opacity: 0, y: 20 }}
        animate={isInView ? { opacity: 1, y: 0 } : {}}
        transition={{ duration: 0.5 }}
      >
        Compare Odds Across 31 Bookmakers
      </motion.h2>

      <motion.p
        className="bookmakers-subtitle"
        initial={{ opacity: 0, y: 20 }}
        animate={isInView ? { opacity: 1, y: 0 } : {}}
        transition={{ duration: 0.5, delay: 0.1 }}
      >
        Find the best prices for every market
      </motion.p>

      <div className="bookmakers-grid">
        {BOOKMAKERS.map((bookmaker, index) => (
          <motion.span
            key={bookmaker}
            className="bookmaker-badge"
            initial={{ opacity: 0, y: 10 }}
            animate={isInView ? { opacity: 1, y: 0 } : {}}
            transition={{
              duration: 0.3,
              delay: 0.2 + index * 0.03,
            }}
          >
            {bookmaker}
          </motion.span>
        ))}
        <motion.span
          className="bookmaker-badge"
          initial={{ opacity: 0, y: 10 }}
          animate={isInView ? { opacity: 1, y: 0 } : {}}
          transition={{
            duration: 0.3,
            delay: 0.2 + BOOKMAKERS.length * 0.03,
          }}
          style={{ color: 'var(--accent)' }}
        >
          +11 more
        </motion.span>
      </div>
    </section>
  )
}
